import { Link } from '@inertiajs/react';

import { assetUrl } from '../../Shared/helpers';
import { Charity, User } from '../../Shared/types';
import { useRouter } from '../router';
import { MainNav } from './MainNav';
import { UserNav } from './UserNav';

export function NavBar({
  charity,
  user,
  segment = null,
}: {
  charity: Charity & { onboarding: boolean; } | null;
  user: User & { charities: Charity[]; admin: boolean; } | null;
  segment?: string | null;
}) {
  const { routes } = useRouter();

  return (
    <div
      className="bg-blue-800 h-[60px] fixed top-0 left-0 right-0 grid items-center px-4 z-50 grid-cols-[1fr_780px_1fr]"
    >
      <div>
        <Link href={routes.home()} className="font-bold font-sm">
          <img src={assetUrl('images/logo-light.svg')} alt="Supporta" width={90} />
        </Link>
      </div>
      <div>
        {charity && <MainNav charity={charity} segment={segment} />}
      </div>
      {user && <UserNav user={user} charity={charity} />}
    </div>
  );
}
